import React, {useEffect, useState} from "react";
import {ToolsBar} from "../toolsBar/ToolsBar";
import {PrivateRoute} from "../../../helpers/PrivateRoute";
import {Pages} from "../pages/pages";
import {FlyerSpotsEditor} from "../spots/FlyerSpotsEditor";
import {FlyerPromosEditor} from "../promos/FlyerPromosEditor";
import {FlyerPromoItemsEditor} from "../promoItems/FlyerPromoItemsEditor";
import {FlyersCatalog} from "../flyersCatalog/mainFlyersCatalog/flyersCatalog";
import {TrashFlyersCatalog} from "../flyersCatalog/trashFlyerCatalog/trashFlyersCatalog";
import {ArchiveFlyersCatalog} from "../flyersCatalog/archiveFlyerCatalog/archiveFlyersCatalog";
import {UploadImagesProgressPopup} from "../uploadImagesProgressPopup/uploadImagesProgressPopup";
import {UserDto} from "../../../dtos";
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {useMediaQuery} from "@mui/material";
import {
    addEventDataTypeListener,
    EVENT_DATA_TYPE_DISABLE_TABS,
    removeEventTypeListener
} from "../../../globals/EventDispatcher";
import {CustomDataEvent} from "../../../globals/CustomDataEvent";
import {ActionType} from "../../../store/actionTypes";
import {FlippingFlyersCatalogCreateEditFlyer} from "../../flippingFlyersCatalog/flippingFlyersCatalogCreateEditFlyer";


export const EditorContent = () => {
    const [isDisabledTabs, setTabsState] = useState(true);
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isAccountTier1 = userDto?.accountTier === 1;
    let {isShowCreateNewFlyerPopup} = useTypedSelector((state) => state.toggleActionsForFlyers);
    const isXs = useMediaQuery(`(max-width:699px)`);
    const flyersState = useTypedSelector((state) => state.flyers);
    const [showWelcomeScreen, setShowWelcomeScreen] = useState<boolean>(false);
    useEffect(() => {
        addEventDataTypeListener(EVENT_DATA_TYPE_DISABLE_TABS, (data: CustomDataEvent) => {
            setTabsState(data.data);
        })
        return () => {
            removeEventTypeListener(EVENT_DATA_TYPE_DISABLE_TABS)
        }
    }, []);

    useEffect(() => {
        if(flyersState.type === ActionType.GET_FLYERS_SUCCESS || ActionType.CHANGE_FLYERS_STATE){
            const isFirstTimeCall = localStorage.getItem(`userEnterForFirstTime${userDto?.userId}`) === "true";
            if(flyersState.flyers.length === 0 && isFirstTimeCall){
                setShowWelcomeScreen(true);
            } else {
                setShowWelcomeScreen(false);
            }
        }
    }, [flyersState.type]);


    return (
        <div className="editors_main_parent">

            {
                !isXs && !showWelcomeScreen &&
                <div className="tools_bar_parent_container">
                    <ToolsBar isDisabledTabs={isDisabledTabs}/>
                </div>
            }
            <div className="editors_parent_container">

                <PrivateRoute path="/flyersCatalog/:flyerId/pages" exact component={Pages}/>
                <PrivateRoute path="/flyersCatalog/:flyerId/frames" exact component={FlyerSpotsEditor}/>
                <PrivateRoute path="/flyersCatalog/:flyerId/promos" exact component={FlyerPromosEditor}/>
                <PrivateRoute path="/flyersCatalog/:flyerId/promoitems" exact component={FlyerPromoItemsEditor}/>
                <PrivateRoute path="/flyersCatalog/flyerId/:flyerId" exact component={FlippingFlyersCatalogCreateEditFlyer}/>
                <PrivateRoute path="/flyersCatalog" exact component={FlyersCatalog}/>
                <PrivateRoute path="/flyersCatalog/trash" exact component={TrashFlyersCatalog}/>
                <PrivateRoute path="/flyersCatalog/archive" exact component={ArchiveFlyersCatalog}/>
            </div>
            <UploadImagesProgressPopup isModal={isAccountTier1 || isShowCreateNewFlyerPopup || isXs}/>
        </div>

    )
}